import {
	suspend,
	resume,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/enhancers/suspender';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import type { MapDispatchToPropsSimple } from '@atlassian/jira-portfolio-3-portfolio/src/common/types/redux';
import { withViewExperienceTracker } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/experience-tracking';
import { connect } from '@atlassian/jira-react-redux';
import mapStateToProps from './query';
import type { Props, StateProps, DispatchProps, OwnProps, InjectedProps } from './types';
import View from './view';

const mapDispatchToProps: MapDispatchToPropsSimple<DispatchProps, OwnProps> = (dispatch) => ({
	onDragStart: () => {
		dispatch(suspend());
	},
	onDragEnd: () => {
		dispatch(resume());
	},
});

const Fields = connect<StateProps, DispatchProps, OwnProps, State>(
	mapStateToProps,
	mapDispatchToProps,
)(View);

// @ts-expect-error - connect does not have a component interface for `why-did-you-render`
Fields.whyDidYouRender = true;
Fields.displayName = 'Fields';

export default withViewExperienceTracker<Flow.Diff<Props, InjectedProps>>(
	Fields,
	'portfolio-3.simple-plans.roadmap.fields-column',
);
